import React, { useEffect, useRef, useState } from 'react'
import ToastService from '../../../../../../../services/toastService/ToastService';
import FormCreator from '../../../../../../../components/finalForms/FormCreator';
import Buttons from '../../../../../../../components/ui/button/Buttons';
import { useImportCoveredMutation } from '../../../../../../../app/services/contractAPI';
import { importContractRenewals } from './ImportContractRenewals.formfield.config';

const ImportContractRenewal = ({ onClose, onSuccess, gridRefresh }) => {
    const formRef = useRef();
    const [formData, setFormData] = useState(importContractRenewals);

    const [importContractRenewal, {
        isLoading: isImporting,
        isSuccess: isImported,
        data: importData
    }] = useImportCoveredMutation();

    const handleImportClick = () => {
        const formData = formRef.current.getFormData();
        if (formData?.scopesImportFile) {
            const file = formData.scopesImportFile[0].base64Data;
            const base64Data = file.split(",")[1];
            const req = {
                base64File: base64Data
            }
            importContractRenewal(req);
        }
    }

    useEffect(() => {
        if (isImported && importData) {
            if (importData?.message?.includes("Missing required")) {
                ToastService.error(importData?.message)
            }
            else {
                ToastService.success(importData?.message);
            }
            onSuccess();
            gridRefresh();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isImported, importData]);

    const resetForm = () => {
        const form = { ...importContractRenewals }
        form.initialState = { ...importContractRenewals.initialState };
        setFormData(form);
    }

    const handleCloseClick = () => {
        resetForm();
        onClose();
    }

    return (
        <div className='col-md-12'>
            <div className='row'>
                <FormCreator
                    ref={formRef}
                    config={formData}
                />
                <div className='d-flex mt-2 justify-content-center'>
                    <Buttons
                        buttonText="Cancel"
                        buttonTypeClassName="btn secondary-btn"
                        onClick={handleCloseClick}
                        titleText="Cancel"
                    />
                    <Buttons
                        buttonText="Import"
                        buttonTypeClassName="btn blue-btn w-full ml-2"
                        onClick={handleImportClick}
                        isLoading={isImporting}
                        titleText="Import"
                    />
                </div>
            </div>
        </div>
    )
}
export default ImportContractRenewal